export default {
  'loyaltySettings.discountRate': '首单折扣',
  'loyaltySettings.discountRate.RG': '首单折扣 - RG',
  'loyaltySettings.discountRate.summary': '会员首次在您餐厅下单享受的折扣率',
  'loyaltySettings.cashBackRate': '返现率',
  'loyaltySettings.cashBackRate.RG': '返现率 - RG',
  'loyaltySettings.cashBackRate.summary': '会员在您餐厅消费获得的返现比例',
  'loyaltySettings.memberStatus': '会员状态',
  'loyaltySettings.memberStatus.new.summary': '在此天数之内注册的会员',
  'loyaltySettings.memberStatus.regular.summary': '在此天数内在您餐厅有消费的会员',
  'loyaltySettings.memberStatus.inactive.summary': '没有在此天数内在您餐厅消费的会员，会被定义为',
  'loyaltySettings.memberRegistrationQRCode': '入会二维码',

  'loyaltySettings.poster.cashbackSummary': '终身享{percent}%返现',

  'loyaltySettings.prepaidCard': '会员卡充值',
  'loyaltySettings.prepaidCard.RG': '会员卡充值 - RG',
  'loyaltySettings.prepaidCard.addNewPurchaseOption': '添加充值配置',
  'loyaltySettings.prepaidCard.removePurchaseOption': '删除',
  'loyaltySettings.prepaidCard.purchaseOption.bonusAmount': '充返金额',
  'loyaltySettings.prepaidCard.purchaseOption.purchaseAmount': '充值金额',
  'loyaltySettings.prepaidCard.purchaseOption.purchaseAmount.isRequired': '请填写充值金额',
  'loyaltySettings.prepaidCard.purchaseOption.bonusAmount.isRequired': '请填写充返金额',
  'loyaltySettings.prepaidCard.successfullyRemoved': '删除充值配置成功!',
  'loyaltySettings.prepaidCard.successfullyCreated': '添加充值配置成功!',
  'loyaltySettings.prepaidCard.successfullyUpdated': '更新充值配置成功',
  'loyaltySettings.prepaidCard.successfullyToggleOn': '会员充值打开!',
  'loyaltySettings.prepaidCard.successfullyToggleOff': '会员充值关闭！',
  'loyaltySettings.prepaidCard.duplicatedPurchaseOption': '存在重复的充值配置',
  'loyaltySettings.prepaidCard.setupTips': '充值选项 (最多10个)',
  'loyaltySettings.prepaidCard.payment.required.verifyCode.titls': '需要手机验证码',
  'loyaltySettings.prepaidCard.payment.required.verifyCode.option.all': '所有会员账户支付',
  'loyaltySettings.prepaidCard.payment.required.verifyCode.option.exceed': '超过一定金额后',
  'loyaltySettings.prepaidCard.recharge.restriction': '充值使用限制',
  'loyaltySettings.prepaidCard.recharge.restriction.immediately': '立即可用',
  'loyaltySettings.prepaidCard.recharge.restriction.afterNDay': '当日不可用',
  'loyaltySettings.prepaidCard.recharge.restriction.afterNDay.addon.after': '天后可用',
  'loyaltySettings.prepaidCard.recharge.restriction.afterNDay.isRequired': '天数不能为空.',
  'loyaltySettings.prepaidCard.recharge.restriction.afterNDay.min': '天数必须大于1.',

  'loyaltySettings.prepaidCard.recharge.custom': '自定义充值',
  'loyaltySettings.prepaidCard.recharge.custom.maximum.bonus.rate': '最大充送比例限制',

  'loyaltySettings.advertistingSetting': '会员推广设置',
  'loyaltySettings.advertistingSetting.enableRelatedMessage': '在扫码点餐/平板点餐上启用会员推广',
  'loyaltySettings.advertistingSetting.enableRelatedMessage.desc':
    '关闭后：扫码点餐不显示入会横幅；平板点餐和扫码点餐，在提交非会员菜时，不会引导用户登录会员。',
  'loyaltySettings.prepaidCard.payment.required.verifyCode.threshold.isRequired': '支付金额阈值不能为空',
  'loyaltySettings.prepaidCard.payment.required.verifyCode.threshold.min': '支付金额阈值必须大于0.',

  'loyalty.memberstatus.new': '新会员',
  'loyalty.memberstatus.regular': '常规会员',
  'loyalty.memberstatus.atrisk': '有风险会员',
  'loyalty.memberstatus.lost': '已丢失会员',

  'loyaltySettings.memberStatus.atrisk.summary': '没有在此天数内在您餐厅消费的会员',
  'loyaltySettings.memberStatus.lost.summary': '没有在此天数内在您餐厅消费的会员',

  'loyaltySettings.autopilot': '自动短信营销',
  'loyaltySettings.autopilot.desc':
    '标记为付费的自动短信场景开启后，发出的短信将纳入crm收费标准：总发送量在crm 套餐内，仅收取套餐费；超出crm套餐的部分将按实际超出量额外收取$0.02/segments',
  'loyaltySettings.autopilot.tips.01': '标记为“收费”的场景开启后，发出的短信将收取费用。',
  'loyaltySettings.autopilot.tips.02':
    'SMS单消息段长度，限制在160个7位字符，即1120位，或140字节。当内容长度超过该限制时，运营商会将内容分成多个消息段，并按SMS消息段收取费用。',
  'loyaltySettings.autopilot.tips.03':
    '出现以下情况，运营商不会发出短信：含有敏感词，例如电子烟、海洛因、毒品、香烟等；电话号码被运营商放入了黑名单。',
  'loyaltySettings.autopilot.newregister': 'New Register',
  'loyaltySettings.autopilot.firstpurchase': 'First Purchase',
  'loyaltySettings.autopilot.repurchase': 'Re-purchase',
  'loyaltySettings.autopilot.atrisk': 'At-risk',
  'loyaltySettings.autopilot.lost': 'Lost',
  'loyaltySettings.autopilot.need.pay': '收费',
  'loyaltySettings.autopilot.toggle.confirm': `开启当前自动短信场景后，发出的短信将纳入crm收费标准：总发送量在crm 套餐内，仅收取套餐费；超出crm套餐的部分将按实际超出量额外收取$0.02/segments`,
  'loyaltySettings.autopilot.link.prefix': `已转移到“短信和彩信营销->自动营销”功能，请`,
  'loyaltySettings.autopilot.link.text': `点击此处前往 >>`,
  'loyaltySettings.advertising.link.prefix': `会员推广设置、入会方式、入会二维码，已转移到新页面，请`,
  'loyaltySettings.advertising.link.text': `点击此处前往 >>`,
  'loyaltySettings.benefits.link.prefix': `首单折扣、返现率等会员权益功能，已转移到新页面，请`,
  'loyaltySettings.benefits.link.text': `点击此处前往 >>`,
  'loyaltySettings.advertisingBenefits.link.title': `推广入会与会员权益`,

  'loyaltySettings.autopilot.newregister.desc':
    'A reward for signing up means the customer starts off with an incentive. It’s a great way to say hello!',
  'loyaltySettings.autopilot.firstpurchase.desc':
    'Over 60% of new customers don’t come back after their first visit, but an extra reminder can cut that number significantly.',
  'loyaltySettings.autopilot.repurchase.desc':
    'Repeat customers drive 80% of your revenue, but if you send them a reminder, you can increase their visit rates. ',
  'loyaltySettings.autopilot.atrisk.desc':
    'A customer’s likelihood to return drops 50-75% every 30 days. We help you engage at-risk customers before it’s too late',
  'loyaltySettings.autopilot.lost.desc': 'Recapture customers who have been inactive from six months up to a year.',

  'loyaltySettings.how.to.join.membership': '入会方式',
  'loyaltySettings.how.to.join.membership.RG': '入会方式 - RG',
  'loyaltySettings.free.join.membership': '免费入会',
  'loyaltySettings.topup.join.membership': '充值入会',
  'loyaltySettings.annual.join.membership': '年费入会',

  'loyaltySettings.annual.join.membership.fee.isRequired': '年费入会金额不能为空',
  'loyaltySettings.annual.join.membership.fee.min': '年费入会金额必须大于0.',
  'loyaltySettings.annual.join.membership.fee.addon.after': '每365天',

  'loyaltySettings.advertistingSetting.enableRelatedMessage.kiosk': '在自助点餐机上启用餐厅会员相关的入口',
  'loyaltySettings.advertistingSetting.enableRelatedMessage.kiosk.desc':
    '关闭后自助点餐机上的会员相关页面或入口将不再显示',

  'loyaltySettings.advertistingSetting.enableLogin': '在扫码点餐/平板点餐上启用会员登录',
  'loyaltySettings.advertistingSetting.enableLogin.desc':
    '关闭后，扫码点餐/平板点餐上，将不再显示会员登录、注册和入会横幅。这将导致积分兑换无法登录，会员价提交时无登录引导.',
  'loyaltySettings.advertistingSetting.enableRegister': '在扫码点餐/平板点餐上启用会员注册',
  'loyaltySettings.advertistingSetting.enableRegister.desc': '关闭后扫码点餐/平板点餐上，不允许注册新会员',

  //Advertising Benefits
  'loyaltySettings.advertisingBenefits.title': '推广与权益',
  'loyaltySettings.advertisingBenefits.tabs.advertising': '推广入会',
  'loyaltySettings.advertisingBenefits.tabs.benefits': '会员权益',

  'loyaltySettings.advertisingBenefits.advertising.setting': '会员推广设置',

  'loyaltySettings.advertisingBenefits.advertising.QRCodeTabletOrdering': '扫码点餐/平板点餐',
  'loyaltySettings.advertisingBenefits.advertising.loyaltySign': '会员登录',
  'loyaltySettings.advertisingBenefits.advertising.loyaltyRegistration': '会员注册',
  'loyaltySettings.advertisingBenefits.advertising.loyaltyPromotion': '会员推广',
  'loyaltySettings.advertisingBenefits.advertising.kiosk': '自助点餐机',
  'loyaltySettings.advertisingBenefits.advertising.loyaltyRelatedMessaging': '会员相关入口',
  'loyaltySettings.advertisingBenefits.advertising.memberRegistrationQR': '入会二维码',
  'loyaltySettings.advertisingBenefits.advertising.QRRegistration': '会员注册',
  'loyaltySettings.advertisingBenefits.advertising.QRRegistration.desc': '关闭后，不支持通过入会二维码注册新会员。',

  'loyaltySettings.advertisingBenefits.benefits.membershipSettings': '入会设置',
  'loyaltySettings.advertisingBenefits.benefits.guests': '入会方式',
  'loyaltySettings.advertisingBenefits.benefits.free': '免费入会',
  'loyaltySettings.advertisingBenefits.benefits.permanently': '永久有效',
  'loyaltySettings.advertisingBenefits.benefits.356days': '有效期365天',
  'loyaltySettings.advertisingBenefits.benefits.period': '有效期自定义',
  'loyaltySettings.advertisingBenefits.benefits.period.desc': '修改有效期只影响新增会员，历史会员不会修改',
  'loyaltySettings.advertisingBenefits.benefits.period.days': '天',
  'loyaltySettings.advertisingBenefits.benefits.topUp': '充值入会',
  'loyaltySettings.advertisingBenefits.benefits.annualFee': '年费入会',
  'loyaltySettings.advertisingBenefits.benefits.QRCode': '入会二维码',

  'loyaltySettings.advertisingBenefits.benefits.setting': '会员权益设置',
  'loyaltySettings.advertisingBenefits.benefits.fistOrderRate': '首单折扣',
  'loyaltySettings.advertisingBenefits.benefits.fistOrderRate.desc': '会员首次下单享受的折扣率',
  'loyaltySettings.advertisingBenefits.benefits.cashback': '返现率',
  'loyaltySettings.advertisingBenefits.benefits.cashback.desc': '会员消费获得的返现比例',
};
